module.exports = __webpack_public_path__ + "img/co2_blue.01cf94aa.svg";